import type { ShortCircuitProperty } from '../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import { NumbersRange } from '../../../domain/NumbersRange';
import type { ForShortCircuitEvaluation } from '../engines/ForShortCircuitEvaluation';
import {
  type EvaluatedElectricCurrentType,
  EvaluatedElectricCurrentSummary
} from './EvaluatedElectricCurrentSummary';

export const evaluateFaultCurrent = (
  shortCircuitProperties: ShortCircuitProperty[],
  evaluate: ForShortCircuitEvaluation
): EvaluatedElectricCurrentType => {
  if (shortCircuitProperties.map(result => result.faultCurrent).length === 0)
    return { type: 'CALCULATION_RESULT_NOT_AVAILABLE' };

  const range = new NumbersRange(
    shortCircuitProperties.map(result => result.faultCurrent.toAmperes())
  );

  if (range.optionalMin === undefined || range.optionalMax === undefined)
    return { type: 'CALCULATION_RESULT_NOT_AVAILABLE' };

  const min = shortCircuitProperties.find(
    gridElement => gridElement.faultCurrent.toAmperes() === range.optionalMin
  );
  const max = shortCircuitProperties.find(
    gridElement => gridElement.faultCurrent.toAmperes() === range.optionalMax
  );

  return EvaluatedElectricCurrentSummary.from(evaluate, min!, max!);
};
